import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { handleInstitucional } from '../../../api/institucional';

const Cta = () => {

  const [institucional, setInstitucional] = useState(null);
  
  useEffect(function() {
    handleInstitucional().then(function(result) {
      if (result[2])
        setInstitucional(result[2]);
    });
  }, []);

  return (
    <>
    {institucional !== null &&
      <section className="cta__area mb--120">
        <div className="container">
          <div className="cta__inner blue-bg fix" style={{backgroundSize: 'cover', backgroundPosition: 'center', backgroundImage: institucional.imagem !== '' ? `url(https://v1.profaprizattera.com.br/uploads/banner/${institucional.imagem})` : 'inherit'}}>
            <div className="row align-items-center">
              <div className="col-xxl-7 col-xl-7 col-lg-8 col-md-8">
                <div className="cta__content">
                  <h3 className="cta__title">{institucional.titulo}</h3>
                </div>
              </div>
              <div className="col-xxl-5 col-xl-5 col-lg-4 col-md-4">
                <div className="cta__more d-md-flex justify-content-end p-relative z-index-1">
                  <Link to={institucional.link_rodape} className="e-btn e-btn-white">{institucional.botao_rodape}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      }
    </>
  );
};

export default Cta;